import React, { useEffect, useState } from "react";
import Form from 'react-bootstrap/Form';
import { Rating } from 'react-simple-star-rating'
import ContentController from "../../apis/controller/content.controller";
import { images } from "../../assets/images";
import { renderImage } from "../../Components/helper/image";
import Validation from "../../Components/helper/validation";
import PageTitle from "../../Components/PageTitle";




function Feedback() {
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState();
    const [feedback, setFeedback] = useState();
    const [breadCrumbs, setBreadcrumbs] = useState();
    const [rateing, setRateing] = useState(20);
    let defaultValues = {
        subject: null,
        email: null,
        desc: null,
        rating: rateing ? rateing : null,
    };
    const [values, setValues] = useState(defaultValues);

    const [isError, setError] = useState({
        subject: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        email: {
            rules: ["required", "email"],
            isValid: true,
            message: "",
        },
        desc: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
        rating: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
    });
    let validation = new Validation(isError);

    const handleStates = (field, value) => {
        /** Validate each field on change */
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        /** Validate each field on change */
        if (!value || !value.trim()) {
            setValues({ ...values, [field]: "" });
        } else {
            setValues({ ...values, [field]: value });
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        setValues(defaultValues);
        getFeedback();
    }, []);

    const addFeedback = async () => {
        /** Check full form validation and submit **/
        let validation = new Validation(isError);
        let isValid = await validation.isFormValid(values);
        if (isValid && !isValid.haveError) {
            setLoader(true);
            let response = await new ContentController().feedbackForm(values);
            if (response && response.status) {
                setSuccess(response.status);
                setSuccessMessage(response.message);
                setValues(defaultValues);
            }
        } else {
            setError({ ...isValid.errors });
            setLoader(false);
        }
    };

    const getFeedback = async () => {
        setLoader(true);
        let res = await new ContentController().feedback();
        if (res && res.status) {
            setFeedback(res.page);
            setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };

    console.log(rateing);

    return (
        <>
            {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
            <section className="feedback_section">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="feedback_inner">
                                {feedback && <h2>
                                    {feedback.title}
                                </h2>}
                                <div className="feed_back_form">
                                    <div className="row">
                                        {feedback && <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="feed-back_img_area">
                                                <img src={feedback.image ? renderImage(feedback.image, 'large') : images.rafiki} alt="" />
                                            </div>
                                        </div>}
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="form_area_met">
                                                <form>
                                                    {success == false ? <div className="row">
                                                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <div className="form-group mb-4 text-center">
                                                                <label for="">How much you liked our website?</label>
                                                                <div className="rated">
                                                                    <Rating
                                                                        onClick={e => setRateing(e)}
                                                                        ratingValue={rateing}
                                                                        showTooltip={false}
                                                                        tooltipDefaultText="ABCD"
                                                                        tooltipArray={["0.1", "0.3", "5.7", "7.8", "EXC"]}
                                                                    />
                                                                    {isError.rating.message ? (
                                                                        <p className="valid-helper">
                                                                            {isError.rating.message}
                                                                        </p>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <div className=" mb-4" controlId="exampleForm.ControlInput1">
                                                                <label>Subject</label>
                                                                <input type="text" className='form-control' placeholder="Subject" onChange={(e) => {
                                                                    handleStates(
                                                                        "subject",
                                                                        e.target.value
                                                                    );
                                                                }}
                                                                    value={values.subject
                                                                        ? values.subject
                                                                        : ``} />{isError.subject.message ? (
                                                                            <p className="valid-helper">
                                                                                {isError.subject.message}
                                                                            </p>
                                                                        ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <div className="mb-4" controlId="exampleForm.ControlInput1">
                                                                <label>Email address</label>
                                                                <input type="email" className='form-control' placeholder="name@example.com" onChange={(e) => {
                                                                    handleStates(
                                                                        "email",
                                                                        e.target.value
                                                                    );
                                                                }}
                                                                    value={values.email
                                                                        ? values.email
                                                                        : ``} />{isError.email.message ? (
                                                                            <p className="valid-helper">
                                                                                {isError.email.message}
                                                                            </p>
                                                                        ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <div className="mb-4" controlId="exampleForm.ControlTextarea1">
                                                                <label>Please leave your feedback below</label>
                                                                <textarea as="textarea" className='form-control' rows={3} placeholder="Write your feedback" onChange={(e) => {
                                                                    handleStates(
                                                                        "desc",
                                                                        e.target.value
                                                                    );
                                                                }}
                                                                    value={values.desc
                                                                        ? values.desc
                                                                        : ``} />{isError.desc.message ? (
                                                                            <p className="valid-helper">
                                                                                {isError.desc.message}
                                                                            </p>
                                                                        ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                            <div className="submit_bt float-right ">
                                                                <button type="button" className="btn-primary_set"
                                                                    onClick={() => {
                                                                        addFeedback()
                                                                    }}
                                                                >Submit</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                        :
                                                        <div className="check_in">
                                                            <i className="fas fa-check-circle"></i>
                                                            <p>{successMessage && successMessage}</p>
                                                        </div>}
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );

}
export default Feedback;